<template>
  <div class="company-card__hint-inner">
    <div class="company-card__hint-icon">
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="8" cy="8" r="8" fill="#64748B" />
        <line
          x1="8"
          y1="12"
          x2="8"
          y2="7"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M8 4L8 3.5"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    </div>
    <div class="company-card__hint-text">
      <!--      {{ $t("company_card.hint.review") }}-->
    </div>
    <div
      class="company-card__hint-arrow"
      v-if="isMobile"
      @click="$emit('toggle')"
    >
      <svg
        width="8"
        height="5"
        viewBox="0 0 8 5"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.26688 4.52433L7.78955 1.0016C7.87109 0.920118 7.91602 0.811354 7.91602 0.695382C7.91602 0.57941 7.87109 0.470646 7.78955 0.38917L7.53019 0.129745C7.36119 -0.0390649 7.08651 -0.0390649 6.91777 0.129745L3.95964 3.08787L0.998234 0.126462C0.916693 0.0449859 0.807993 0 0.692085 0C0.576049 0 0.467349 0.0449859 0.385744 0.126462L0.126448 0.385887C0.0449071 0.467428 -1.43051e-05 0.576128 -1.43051e-05 0.6921C-1.43051e-05 0.808072 0.0449071 0.916836 0.126448 0.998313L3.65233 4.52433C3.73413 4.606 3.84335 4.65086 3.95945 4.6506C4.076 4.65086 4.18515 4.606 4.26688 4.52433Z"
          fill="#666D79"
        />
      </svg>
    </div>

    <div class="company-card__hint-timer">
      <div class="company-card__hint-timer-title"></div>
      <div class="company-card__hint-timer-value"></div>
    </div>
  </div>
</template>

<script>
import responsiveMixin from '@vue-app/mixins/responsive-mixin'

export default {
  name: 'CompanyCardHintPending',
  mixins: [responsiveMixin],
  emits: ['toggle'],
}
</script>

<style lang="scss" scoped>
@import '@css-app/variables';
.company-card {
  &__hint {
    &-inner {
      display: flex;
      align-items: flex-start;
      background: rgba(#64748B, 0.2);
      border-radius: 15px;
      padding: 15px 25px 25px 50px;
    }

    &-icon {
      width: 16px;
      height: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 5px;
      margin-right: 10px;

      svg,
      img {
        max-width: 100%;
        max-height: 100%;
      }
    }

    &-text {
      display: flex;
      align-items: center;
      border-radius: 15px;
    }
  }
}
</style>
